import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import Main_Winter from '../../component/Winter/Main_Winter';
import Save_Date_Fall from '../../component/Fall/Save_Date_Fall';
import axios from 'axios';
import Info_Fall from '../../component/Fall/Info_Fall';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList2 from '../../component/Account/AccountList2';
import CallInfo from '../../component/CallInfo';
import ParentInfo from '../../component/Info/ParentInfo';
import Information from '../../component/Information';

const YunSoYeon = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "김민재 ♥ 윤소연 결혼합니다.";
    const openDesc = "25년 9월 27일 오전 11시";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/269/thumb1.jpg";

    const lng = 127.467290808116;
    const lat = 36.6204643244043 ;
    
    const placeTelNum = "043-292-8525";

    const desc = " * 청주CJB미디어센터내 위치 *"
    const forBus = "시내 버스이용시 : 843, 30-1, 823, 851 등을 이용\n청주시외버스터미널 출발 기준 택시 이용시 약 10분"
    const forCar = "내비게이션 에스가든웨딩청주 입력"

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    const conceptStyle = {
        concept: "WINTER",
        titleColor: "#000000",
        pointColor: "#000000",
        btnBgColor: "#000000",
        fontColor: "#ffffff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F4F4F4",
        fontFamilyKo: "JejuMyeongjo",
        fontFamilyEn: "Milchella"
    }


    const parents = [
        {groom : "박상윤 · 김미영의 장남"},
        {bride : "김명광 · 이명자의 장녀"}
    ]

    const parentInfo = {
        groom: {
            dad: { name: "최종국", isDeceased: false },
            mom: { name: "김복희", isDeceased: false },
            role: "차남",
        },
        bride: {
            dad: { name: "박민규", isDeceased: false },
            mom: { name: "안혜자", isDeceased: false },
            role: "장녀",
        }
    };

    const title = "저희, 결혼합니다"

    const msg1 = "곱게 물든 단풍으로 가득 찰 가을날\n저희도 서로에게 물들어 평생 함께 하고자 합니다.";
    const msg2 = "서로 다른 색으로 만났지만\n앞으로 서로에게 어울리는 색이 되도록\n사랑하고 배려하며 살겠습니다."
    const msg3 = "하나가 되는 약속의 시간에\n소중한 분들을 모시고자 하오니\n저희의 하나 됨을 지켜봐 주시고\n앞날을 축복해 주시면 감사하겠습니다."

    const groomAccountList = [
        {
            role: "신랑",
            name: "김민재",
            bank: "우리은행",
            accountNumber : "1002-163-022313",
            isKakao : false
        }
        ,{
            role: "신랑 부",
            name: "김동환",
            bank: "우리은행",
            accountNumber : "1002-649-416309",
            isKakao : false
        }
        ,{
            role: "신랑 모",
            name: "윤미자",
            bank: "농협은행",
            accountNumber : "173429-52-101664",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "윤소연",
            bank: "신한은행",
            accountNumber : "110-333-355906",
            isKakao : false
        }
        ,{
            role: "신부 부",
            name: "윤철현",
            bank: "하나은행",
            accountNumber : "658-910126-12607",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "이명희",
            bank: "국민은행",
            accountNumber : "713701-01-160884",
            isKakao : false
        }
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "김민재",
            call: "010-2611-3267"
        }
        ,{
            role: "신랑 부",
            name: "김동환",
            call: "010-5487-3267"
        }
        ,{
            role: "신랑 모",
            name: "윤미자",
            call: "010-9426-3267"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "윤소연",
            call: "010-7924-9751"
        }
        ,{
            role: "신부 부",
            name: "윤철현",
            call: "010-6645-9577"
        }
        ,{
            role: "신부 모",
            name: "이명희",
            call: "010-9380-8449"
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "지하철 앞",
            brideAnswer: "당연하지!"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "긴장 돼",
            brideAnswer: "두근두근"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "널 사랑해",
            brideAnswer: "사랑해❤️"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "한눈 안 팜",
            brideAnswer: "절대 지켜"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "행복하자",
            brideAnswer: "고마워"
        }
    ]

    const informationList =[
        {
            title : "피로연 안내",
            content : "날짜 7월 10일 오전 11시 ~ 오후 3시\n장소 충남 태안군 안면읍 백사장 1길 91\n진미각 중화요리"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#000000"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Winter width={"300px"} weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstNameEn(weddingData.brideNameEn)} groomNameEn={getFirstNameEn(weddingData.groomNameEn)} />
                    <Save_Date_Fall weddingData={weddingData} color={conceptStyle.titleColor} />
                    <Info_Fall  conceptStyle={conceptStyle} weddingData={weddingData} />
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle} />
                    <CallInfo marginTop={"30px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper>  */}
                    <Dday_Spring groomName={getFirstKoName(weddingData.brideName)} brideName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring  weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    {/* <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    </MotionWrapper> */}
                    {/* <Information conceptStyle={conceptStyle} informationList={informationList} /> */}
                    <MotionWrapper initialY={50}>
                        <Location_Spring  weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc desc={desc} forCar={forCar} forBus={forBus} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default YunSoYeon;